import { render, staticRenderFns } from "./WxMaterialSelect.vue?vue&type=template&id=af89f852&scoped=true"
import script from "./WxMaterialSelect.vue?vue&type=script&lang=js"
export * from "./WxMaterialSelect.vue?vue&type=script&lang=js"
import style0 from "./WxMaterialSelect.vue?vue&type=style&index=0&id=af89f852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af89f852",
  null
  
)

export default component.exports